// vim: set ts=2 sts=2 sw=2 et:
// Shared dark-theme styles for react-select components across the app.
// Import `reactSelectDarkStyles` and pass it as the `styles` prop.

const BG = "#2c2926";
const BG_HOVER = "rgba(201, 55, 23, 0.14)";
const BG_SELECTED = "rgba(201, 55, 23, 0.28)";
const BORDER = "#3f3f46";
const BORDER_FOCUS = "#c93717";
const TEXT = "#f4f4f5";
const TEXT_MUTED = "#a1a1aa";
const CHIP_BG = "#353230";
const SHADOW_FOCUS = "0 0 0 0.2rem rgba(201, 55, 23, 0.25)";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reactSelectDarkStyles: Record<string, (base: any, state: any) => any> = {
  control: (base: object, state: { isFocused: boolean }) => ({
    ...base,
    backgroundColor: BG,
    borderColor: state.isFocused ? BORDER_FOCUS : BORDER,
    boxShadow: state.isFocused ? SHADOW_FOCUS : "none",
    "&:hover": {
      borderColor: state.isFocused ? BORDER_FOCUS : BORDER,
    },
    color: TEXT,
    minHeight: "calc(1.5em + 0.75rem + 2px)",
  }),
  menu: (base: object) => ({
    ...base,
    backgroundColor: BG,
    border: `1px solid ${BORDER}`,
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    zIndex: 9999,
  }),
  menuList: (base: object) => ({
    ...base,
    padding: 0,
  }),
  option: (base: object, state: { isSelected: boolean; isFocused: boolean }) => ({
    ...base,
    backgroundColor: state.isSelected ? BG_SELECTED : state.isFocused ? BG_HOVER : BG,
    color: TEXT,
    cursor: "default",
    "&:active": {
      backgroundColor: BG_SELECTED,
    },
  }),
  multiValue: (base: object) => ({
    ...base,
    backgroundColor: CHIP_BG,
  }),
  multiValueLabel: (base: object) => ({
    ...base,
    color: TEXT,
  }),
  multiValueRemove: (base: object) => ({
    ...base,
    color: TEXT_MUTED,
    "&:hover": {
      backgroundColor: "rgba(201, 55, 23, 0.35)",
      color: TEXT,
    },
  }),
  input: (base: object) => ({
    ...base,
    color: TEXT,
  }),
  placeholder: (base: object) => ({
    ...base,
    color: TEXT_MUTED,
  }),
  singleValue: (base: object) => ({
    ...base,
    color: TEXT,
  }),
  indicatorSeparator: (base: object) => ({
    ...base,
    backgroundColor: BORDER,
  }),
  dropdownIndicator: (base: object) => ({
    ...base,
    color: TEXT_MUTED,
    "&:hover": { color: TEXT },
  }),
  clearIndicator: (base: object) => ({
    ...base,
    color: TEXT_MUTED,
    "&:hover": { color: TEXT },
  }),
  noOptionsMessage: (base: object) => ({
    ...base,
    color: TEXT_MUTED,
  }),
};
